import type { FaireProductEntity } from "../../entity_types/product";

export const p_22kvt4qdd6: FaireProductEntity = {
  token: "p_22kvt4qdd6",
  type: "product",
  name: "Safari Baby Knit Polo & Shorts Set (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ce10d10cda974c8ed380b38cfbab8205df2b291d9ac77a4ee7457f7dbca06609.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f21d5e33e011dd353e895125cf7817ef932e6546985ecbcb3cc686f2136d6c6.png",
    "https://cdn.faire.com/fastly/94aaf3adc4402caeb259dbaf18a621ea916fa12000b1d4c8c950c7117331d432.png",
    "https://cdn.faire.com/fastly/05bb0c5fd87948e532268fe252bde3931cfce9fd0ca8944955caa7102d98e697.png",
    "https://cdn.faire.com/fastly/f27d12a9ff38d9463b6baf06b08d76e45a9bcc9c64e6f011b679c96d85f2b6cc.png",
    "https://cdn.faire.com/fastly/27cc933cc333c1bd7958e5c44f4582d9551f84888bcabb51af34492d38bf8897.png",
    "https://cdn.faire.com/fastly/f99291d151eea6887338c5aae041aa9cf545ccfe7401cfec49e1e0411270f4e4.png",
  ],
  priceDollars: 34,
  description:
    "Timeless, soft, and naturally breathable, this premium organic cotton Safari Short Sleeve Baby Knit Polo & Shorts Set is thoughtfully crafted for lightweight everyday comfort.\n\nOur 100% organic cotton baby sweater is thoughtfully made as a truly special piece, blending timeless beauty, comfort, and sustainability. Designed for families who value thoughtfully made organic baby clothes, it reflects heirloom-quality craftsmanship and refined design.\n\nWhy It’s Special:\n\n• Heirloom-Quality Organic Cotton\nBreathable, 100% organic cotton with exceptional softness and a beautiful finish.\n\n• Safe, Non-Toxic & Gentle\nEco-friendly, chemical-free materials and gentle dyes for delicate skin.\n\n• Crafted to Last\nMeticulous detailing ensures lasting quality and comfort.\n\n• Designed in the USA, Responsibly Made\nDesigned in the USA and ethically produced in India, supporting sustainable practices.\n\n• Timeless Design\nWhimsical yet refined details for everyday moments and special occasions.\n\nPerfect for Gifting\nWith its heirloom-quality feel and timeless design, this organic cotton baby sweater makes a meaningful gift for baby showers, newborns, and first holidays.\n\nChoose Viverano Organics for heirloom-quality organic baby clothing—thoughtfully designed for little ones and the planet. Happy baby. Happy earth.",
  tags: [],
  msrpDollars: 68,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:50.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
